import { Card, CardBody, CardHeader } from "@nextui-org/react";
import { ChefHatIcon, Icon } from "lucide-react";
import { useChatStore } from "../states";

export default function MobileFeatureCard() {

  const { setMessage } = useChatStore();

  const onClickDiv = (description: string) => {
    const textarea = document.getElementById("prompt-input");
    setMessage(description)
    if (textarea) {
      textarea.focus();
    }
  }
  const messages = [
    {
      key: "message1",
      description: "Explain quantum computing in simple terms",
      icon: <ChefHatIcon className="text-primary-700" width={24} />,
    },
    {
      key: "message2",
      description: "Got any creative ideas for a 10 year old' birthday?",
      icon: <ChefHatIcon className="text-primary-700" width={24} />,
    },
    {
      key: "message3",
      description: "How do I make an HTTP request in Javascript?",
      icon: <ChefHatIcon className="text-primary-700" width={24} />,
    }
  ];

  return (
    <div className="grid gap-2 grid-cols-1 mx-12 mb-12">
      {messages.map((message) => (
        <Card
          key={message.key}
          className="h-auto bg-default-100 px-[20px] py-[16px]"
          shadow="none"
        >
          <CardHeader className="p-0 pb-[9px]">{message.icon}</CardHeader>
          <CardBody className="p-0 text-small text-default-400 cursor-pointer" onClick={() => onClickDiv(message.description)}>
            {message.description}
          </CardBody>
        </Card>
      ))}
    </div>
  )
}